import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const IOS_APP_STORE_URL = 'https://apps.apple.com/us/app/circles-verified/id1670176496';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.renelabs.circlesocial';
const PREVIEW_URL = 'https://api.circlesverified.com/functions/v1/campus-event-preview';

function getDeviceStoreUrl() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera || '';
  if (/android/i.test(userAgent)) return PLAY_STORE_URL;
  return IOS_APP_STORE_URL;
}

function getDeviceType() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera || '';
  if (/android/i.test(userAgent)) return 'android';
  if (/ipad|iphone|ipod/i.test(userAgent)) return 'ios';
  return 'other';
}

function getHangoutId(search) {
  return new URLSearchParams(search).get('hangoutId');
}

function getAndroidIntentUrl(pathname, search) {
  const appPath = pathname.replace(/^\/?app\/?/, '');
  return `intent://${appPath}${search || ''}#Intent;scheme=circlesverified;package=com.renelabs.circlesocial;S.browser_fallback_url=${encodeURIComponent(PLAY_STORE_URL)};end`;
}

function getNativeAppUrl(pathname, search) {
  const appPath = pathname.replace(/^\/?app\/?/, '');
  return `circlesverified://${appPath}${search || ''}`;
}

function openAppStoreThenDeepLink(pathname, search) {
  window.location.href = IOS_APP_STORE_URL;

  window.setTimeout(() => {
    window.location.href = getNativeAppUrl(pathname, search);
  }, 150);

  window.setTimeout(() => {
    window.location.href = getNativeAppUrl(pathname, search);
  }, 450);
}

function openNativeAppOrStore(pathname, search) {
  const deviceType = getDeviceType();

  if (deviceType === 'ios') {
    openAppStoreThenDeepLink(pathname, search);
    return () => {};
  }

  if (deviceType === 'android') {
    window.location.href = getAndroidIntentUrl(pathname, search);
    return () => {};
  }

  window.location.href = getDeviceStoreUrl();
  return () => {};
}

const StoreRedirect = ({ location }) => {
  useEffect(() => {
    return openNativeAppOrStore(window.location.pathname, window.location.search);
  }, [location]);

  return (
    <main className="store-redirect">
      <img
        className="app-icon"
        src="https://play-lh.googleusercontent.com/i9SpGXZp6yMpxYaj1-JV419eV73ZjA6RCJh6A50vvwxlPYIpdj2TioKvu_2ISERTjw=w240-h480-rw"
        alt="Circles Verified"
      />
      <p>Opening Circles Verified...</p>
      <a href={IOS_APP_STORE_URL} target="_blank" rel="noopener noreferrer" className="download-link">
        iOS
      </a>
      <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" className="download-link">
        Android
      </a>
    </main>
  );
};

const HangoutPreview = ({ hangoutId }) => {
  const previewSrc = `${PREVIEW_URL}?hangoutId=${encodeURIComponent(hangoutId)}&noDeepLink=1`;

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== 'https://api.circlesverified.com') return;
      if (event.data?.type !== 'circles-open-app') return;

      const nextHangoutId = event.data.hangoutId || hangoutId;
      openNativeAppOrStore('/app/hangout', `?hangoutId=${encodeURIComponent(nextHangoutId)}`);
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [hangoutId]);

  return (
    <main className="hangout-preview-shell">
      <iframe
        title="Circles hangout preview"
        src={previewSrc}
        className="hangout-preview-frame"
        allow="clipboard-write"
      />
    </main>
  );
};

const RedirectPage = () => {
  const location = useLocation();
  const isHangoutRoute = /^\/app\/hangout\/?$/i.test(location.pathname);
  const hangoutId = getHangoutId(location.search);

  if (isHangoutRoute && hangoutId) {
    return <HangoutPreview hangoutId={hangoutId} />;
  }

  return <StoreRedirect location={location} />;
};

export default RedirectPage;
